export default __webpack_public_path__ + "static/media/yyi2SKQwBy.e70cd892.png";